module.exports = __webpack_public_path__ + "img/twitch.158d5614.svg";